<template>
	<div class="mobile-hide shadow-1" color="white">
		<div class="row q-py-md q-px-md fit justify-center">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-2">
						<img :src="logo" style="max-width: 100%; max-height: 50px;" height="auto" />
					</div>

					<div class="col-10 text-right self-center">
						<q-btn flat dense size="lg" :color="'admin_overview' === $route.name ? 'primary' : 'secondary'"
							:label="$t('overview')" @click="$router.push({ name: 'admin_overview' })" />

						<q-btn-dropdown flat dense size="lg" :label="$t('records')" :color="getColorRegistrations()"
							v-if="showUsers || showOrganization || showTags || showImport">
							<q-list link>
								<q-list-header v-if="showUsers">{{ $t('users') }}</q-list-header>

								<q-item v-for="(content, index) in users" :key="'ru' + index" :to="{ name: content.to }"
									v-if="showMenu(content.meta) && showUsers">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showOrganization" />

								<q-list-header v-if="showOrganization">{{
							$t('organization')
						}}</q-list-header>

								<q-item v-for="(content, index) in organization" :key="'ro' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showOrganization">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showTags" />

								<q-list-header v-if="showTags">{{ $t('tags') }}</q-list-header>

								<q-item v-for="(content, index) in tags" :key="'tg' + index" :to="{ name: content.to }"
									v-if="showMenu(content.meta) && showTags">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showImport" />

								<q-list-header v-if="showImport">{{ $t('import') }}</q-list-header>

								<q-item v-for="(content, index) in importUser" :key="'imp' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showImport">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" :label="$t('trainings')" :color="getColorTraining()" v-if="showOnline ||
							showPresential ||
							showTrails ||
							showPodcasts ||
							showWebinars ||
							showLiveClasses
							">
							<q-list link>
								<q-list-header v-if="showOnline">{{ $t('online') }}</q-list-header>

								<q-item v-for="(content, index) in online" :key="'to' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showOnline">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showLiveClasses" />

								<q-list-header v-if="showLiveClasses">{{
							$t('live_classes')
						}}</q-list-header>

								<q-item v-for="(content, index) in liveClasses" :key="'lc' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showLiveClasses">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showPresential" />

								<q-list-header v-if="showPresential">{{
							$t('presential')
						}}</q-list-header>

								<q-item v-for="(content, index) in presential" :key="'tp' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showPresential">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showTrails" />

								<q-list-header v-if="showTrails">{{ $t('trails') }}</q-list-header>

								<q-item v-for="(content, index) in trails" :key="'tt' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showTrails">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showWebinars" />

								<q-list-header v-if="showWebinars">{{
							$t('webinars')
						}}</q-list-header>

								<q-item v-for="(content, index) in webinars" :key="'tw' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showWebinars">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showPodcasts" />

								<q-list-header v-if="showPodcasts">{{
							$t('podcasts')
						}}</q-list-header>

								<q-item v-for="(content, index) in podcasts" :key="'tpp' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showPodcasts">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" :label="$t('communications')"
							:color="getColorComunications()" v-if="showSurveys ||
							showMessages ||
							showNews ||
							showFaq ||
							showBanners ||
							showCalendar ||
							showDrills
							">
							<q-list link>
								<q-list-header v-if="showSurveys">{{
							$t('surveys')
						}}</q-list-header>

								<q-item v-for="(content, index) in surveys" :key="'cs' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showSurveys">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showMessages" />

								<q-list-header v-if="showMessages">{{
							$t('messages')
						}}</q-list-header>

								<q-item v-for="(content, index) in messages" :key="'cm' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showMessages">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showNews" />

								<q-list-header v-if="showNews">{{ $t('news') }}</q-list-header>

								<q-item v-for="(content, index) in news" :key="'cn' + index" :to="{ name: content.to }"
									v-if="showMenu(content.meta) && showNews">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showFaq" />

								<q-list-header v-if="showFaq">{{ $t('faq') }}</q-list-header>

								<q-item v-for="(content, index) in faq" :key="'cf' + index" :to="{ name: content.to }"
									v-if="showMenu(content.meta) && showFaq">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showBanners" />

								<q-list-header v-if="showBanners">{{
							$t('banners')
						}}</q-list-header>

								<q-item v-for="(content, index) in banners" :key="'cb' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showBanners">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>

								<q-item-separator v-if="showBanners" />

								<!-- <q-list-header v-if="showCalendar">{{
									$t('calendar')
								}}</q-list-header> -->

								<!-- <q-item
									v-for="(content, index) in calendar"
									:key="'cc' + index"
									:to="{ name: content.to }"
									v-if="showMenu(content.meta) && showCalendar"
								>
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item> -->
								<q-item-separator v-if="showDrills" />

								<q-list-header v-if="showDrills">{{
							$t('drills')
						}}</q-list-header>

								<q-item v-for="(content, index) in drills" :key="'dr' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showDrills">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" :label="$t('store')" :color="getColorRewards()"
							v-if="showRewards">
							<q-list link>
								<q-list-header v-if="showRewards">{{ $t('store') }}</q-list-header>

								<q-item v-for="(content, index) in rewards" :key="'rw' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showRewards">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" :label="$t('files')" :color="getColorFiles()"
							v-if="showLibrarys">
							<q-list link>
								<q-list-header v-if="showUsers">{{ $t('library') }}</q-list-header>

								<q-item v-for="(content, index) in librarys" :key="'ruu' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showLibrarys">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" :label="$t('4traders')" :color="getColorFourTraders()"
							v-if="showFourTraders">
							<q-list link>
								<q-list-header v-if="showFourTraders">{{
							$t('4traders')
						}}</q-list-header>

								<q-item v-for="(content, index) in fourtraders" :key="'ft' + index"
									:to="{ name: content.to }" v-if="showMenu(content.meta) && showFourTraders">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>

						<q-btn-dropdown flat dense size="lg" icon="fal fa-cog" :color="getColorConfigurations()"
							v-if="is_superuser">
							<q-list link>
								<q-list-header>{{ $t('configuration') }}</q-list-header>

								<q-item v-for="(content, index) in configurations" :key="'cas' + index"
									:to="{ name: content.to }" v-if="content.hide !== true">
									<q-item-side :icon="content.icon" />
									<q-item-main :label="$t(content.text)" />
								</q-item>
							</q-list>
						</q-btn-dropdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin', 'trails', 'rewards'] },

	data() {
		return {
			system_config: [
				{
					icon: 'far fa-list-ul',
					to: 'admin_config',
					text: 'configuration',
					meta: 'configuration',
				},
				{
					icon: 'far fa-clipboard-list-check',
					to: 'admin_terms',
					text: 'terms_and_conditions',
					meta: 'terms',
				},
				{
					icon: 'far fa-chalkboard',
					to: 'admin_about',
					text: 'about_the_company',
					meta: 'about',
				},
				{
					icon: 'far fa-user-secret',
					to: 'admin_policy',
					text: 'privacy_policy',
					meta: 'policy',
				},
				{
					icon: 'far fa-award',
					to: 'admin_badges',
					text: 'badges',
					meta: 'badges',
				},
				{
					icon: 'far fa-home',
					to: 'admin_home',
					text: 'home',
					meta: 'home',
				},
				{
					icon: 'far fa-cloud-upload',
					to: 'admin_imports',
					text: 'import',
					meta: 'admin_import',
				},
			],
			logo: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
			user_module_items: 'common/user_module_items',
			is_superuser: 'common/is_superuser',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		clientParams() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) return obj
			}
			return null
		},

		users() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-user',
							to: 'admin_users',
							text: 'users',
							meta: 'users',
						},
						{
							icon: 'far fa-users',
							to: 'admin_users_groups',
							text: 'users_groups',
							meta: 'users_groups',
						}
					)
				}
			}
			return contents
		},

		showUsers() {
			let show = false

			this.users.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		librarys() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj && obj.has_library) {
					contents.push({
						icon: 'far fa-list',
						to: 'admin_library_categories',
						text: 'library_categories',
						meta: 'library_categories',
					})

					contents.push({
						icon: 'far fa-books',
						to: 'admin_libraries',
						text: obj.title_library == '' ? 'library' : obj.title_library,
						meta: 'library',
					})
				}
			}
			return contents
		},

		showLibrarys() {
			let show = false
			this.librarys.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		organization() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-city',
							to: 'admin_headquarters',
							text: 'headquarters',
							meta: 'headquarter',
						},
						{
							icon: 'far fa-building',
							to: 'admin_branches',
							text: 'branches',
							meta: 'branch',
						}
					)
				}
			}
			return contents
		},

		showOrganization() {
			let show = false

			this.organization.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		tags() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-hashtag',
						to: 'admin_tags',
						text: 'tags',
						meta: 'tags',
					})
				}
			}
			return contents
		},

		showTags() {
			let show = false

			this.tags.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		online() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-graduation-cap',
						to: 'admin_trainings',
						text: obj.title_trainings == '' ? 'courses' : obj.title_trainings,
						meta: 'trainings',
					})
				}
			}
			return contents
		},

		showOnline() {
			if (this.clientParams && this.clientParams.has_courses) {
				let show = false

				this.online.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		presential() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-clipboard-list-check',
							to: 'courses_catalog',
							text: 'courses_catalog',
							meta: 'presential_manager_catalog',
						},
						{
							icon: 'far fa-users-class',
							to: 'planned_vacancies',
							text: 'planned_vacancies',
							meta: 'presential_manager_seats',
						},
						{
							icon: 'far fa-list',
							to: 'appointments',
							text: 'appointments',
							meta: 'appointments',
						},
						{
							icon: 'far fa-calendar-alt',
							to: 'presential_calendar',
							text: 'calendar',
							meta: 'appointments',
						},
						{
							icon: 'far fa-calendar-star',
							to: 'appointment_types',
							text: 'appointment_types',
							meta: 'appointment_types',
						},
						{
							icon: 'far fa-boxes',
							to: 'product_categories',
							text: 'categories_modules',
							meta: 'product_categories',
						},
						{
							icon: 'far fa-box',
							to: 'products',
							text: 'products_themes',
							meta: 'products',
						},
						{
							icon: 'far fa-tools',
							to: 'support_materials',
							text: 'inputs',
							meta: 'support_materials',
						}
					)
				}
			}
			return contents
		},

		showPresential() {
			if (this.clientParams && this.clientParams.has_presential) {
				let show = false

				this.presential.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
					if (i.meta === 'presential_manager_catalog') {
						let client = this.clients.find((obj) => {
							return obj.id === this.id_user_client_selected
						})
						if (client.presential_event_catalog) show = true
					}
				})
				return show
			} else return false
		},

		trails() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-map-signs',
						to: 'admin_trails',
						text: obj.title_trails == '' ? 'trails' : obj.title_trails,
						meta: 'trails',
					})
					if (obj.has_trail_category) {
						contents.push({
							icon: 'far fa-list',
							to: 'admin_trail_categories',
							text: 'trail_categories',
							meta: 'trails',
						})
					}
				}
			}
			return contents
		},

		showTrails() {
			if (this.clientParams && this.clientParams.has_trails) {
				let show = false

				this.trails.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		webinars() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-broadcast-tower',
						to: 'admin_webcasts',
						text: obj.title_webcasts == '' ? 'live' : obj.title_webcasts,
						meta: 'webcasts',
					})
				}
			}
			return contents
		},

		showWebinars() {
			if (this.clientParams && this.clientParams.has_webcasts) {
				let show = false

				this.webinars.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		podcasts() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-podcast',
						to: 'admin_podcasts',
						text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts,
						meta: 'podcasts',
					})
				}
			}
			return contents
		},

		showPodcasts() {
			if (this.clientParams && this.clientParams.has_podcasts) {
				let show = false

				this.podcasts.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		liveClasses() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'fal fa-chalkboard-teacher',
						to: 'admin_live_classes',
						text:
							obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes,
						meta: 'live_classes',
					})
				}
			}
			return contents
		},

		showLiveClasses() {
			if (this.clientParams && this.clientParams.has_live_classes) {
				let show = false

				this.liveClasses.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		fourtraders() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-list-alt',
							to: '4traders_questions',
							text: 'questions',
							meta: '4traders_questions',
						},
						{
							icon: 'far fa-tasks',
							to: '4traders_tasks',
							text: 'tasks',
							meta: '4traders_tasks',
						}
					)
				}
			}
			return contents
		},

		showFourTraders() {
			if (this.clientParams && this.clientParams.has_4traders) {
				let show = false

				this.fourtraders.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		surveys() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-poll-people',
						to: 'admin_surveys',
						text: 'surveys',
						meta: 'surveys',
					})
				}
			}
			return contents
		},

		showSurveys() {
			let show = false

			this.surveys.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		drills() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-poll-people',
						to: 'admin_drills',
						text: 'drills',
						meta: 'drills',
					})
				}
			}
			return contents
		},

		showDrills() {
			let show = false

			this.drills.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		rewards() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})

				if (obj) {
					contents.push({
						icon: 'far fa-store',
						to: 'admin_rewards',
						text: 'products',
						meta: 'rewards',
					})

					contents.push({
						icon: 'far fa-shopping-cart',
						to: 'admin_auditory',
						text: 'Resgates',
						meta: 'rewards',
					})
				}
			}
			return contents
		},

		showRewards() {
			const client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})

			let show = false

			this.rewards.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && client.has_rewards_store
					})

					if (obj) show = true
				}

			})

			return show
		},

		messages() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-comment',
						to: 'admin_messages',
						text: 'messages',
						meta: 'messages',
					})
				}
			}
			return contents
		},

		showMessages() {
			let show = false

			this.messages.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		news() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj && obj.has_news) {
					contents.push({
						icon: 'far fa-newspaper',
						to: 'admin_news',
						text: obj.title_news === '' ? 'news' : obj.title_news,
						meta: 'news',
					})
				}
			}
			return contents
		},

		showNews() {
			let show = false

			this.news.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		faq() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-question-circle',
							to: 'admin_faqs',
							text: obj.title_faq === '' ? 'faq' : obj.title_faq,
							meta: 'faq',
						},
						{
							icon: 'far fa-list',
							to: 'admin_faq_categories',
							text: 'faq_categories',
							meta: 'faq_categories',
						}
					)
				}
			}
			return contents
		},

		showFaq() {
			let show = false
			let hasFaq = false

			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					hasFaq = obj.has_faq
				}
			}

			this.faq.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj && hasFaq) show = true
				}
			})
			return show
		},

		banners() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-sign',
							to: 'admin_banners',
							text: 'banners',
							meta: 'banners',
						},
						{
							icon: 'far fa-sign-in',
							to: 'banners_welcome',
							text: 'banners_welcome',
							meta: 'banners_welcome',
						}
					)
				}
			}
			return contents
		},

		showBanners() {
			let show = false

			this.banners.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		// calendar() {
		// 	let contents = []
		// 	if (this.id_user_client_selected) {
		// 		let obj = this.clients.find((obj) => {
		// 			return obj.id === this.id_user_client_selected
		// 		})
		// 		if (obj) {
		// 			contents.push({
		// 				icon: 'far fa-calendar-alt',
		// 				to: 'schedules',
		// 				text: 'calendar',
		// 				meta: 'calendar',
		// 			})
		// 		}
		// 	}
		// 	return contents
		// },
		/*
		showCalendar() {
			if (this.clientParams && this.clientParams.has_calendar) {
				let show = false

				this.calendar.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},
*/
		importUser() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-cloud-upload',
						to: 'admin_imports',
						text: 'import',
						meta: 'admin_import',
					})
				}
			}
			return contents
		},

		showImport() {
			let show = false

			this.importUser.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		showBadges() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return client.has_badges ? client.has_badges : false
		},

		configurations() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-list-ul',
							to: 'admin_config',
							text: 'configuration',
							meta: 'configuration',
						},
						{
							icon: 'far fa-chalkboard',
							to: 'admin_about',
							text: 'about_the_company',
							meta: 'about',
						},
						{
							icon: 'far fa-clipboard-list-check',
							to: 'admin_terms',
							text: 'terms_and_conditions',
							meta: 'terms',
						},
						{
							icon: 'far fa-user-secret',
							to: 'admin_policy',
							text: 'privacy_policy',
							meta: 'policy',
						},
						{
							icon: 'far fa-cookie-bite',
							to: 'admin_cookies_policy',
							text: 'cookies_policy',
							meta: 'cookies_policy',
						},
						{
							icon: 'far fa-award',
							to: 'admin_badges',
							text: 'badges',
							meta: 'badges',
							hide: !this.showBadges
						},
						{
							icon: 'far fa-home',
							to: 'admin_home',
							text: 'home',
							meta: 'home',
						},
						{
							icon: 'far fa-window-restore',
							to: 'admin_wild_cards',
							text: 'Wild Cards',
							meta: 'wild_card',
						},
						{
							icon: 'far fa-file-upload',
							to: 'import_code',
							text: 'code_apple',
							meta: 'import_code',
						},
						{
							icon: 'far fa-globe',
							to: 'area_config',
							text: 'areas',
							meta: 'area_config',
						},
						{
							icon: 'far fa-mailbox',
							to: 'mailing_list_config',
							text: 'mailing_list',
							meta: 'mailing_list',
						}
					)
				}
			}
			return contents
		},
	},

	methods: {
		showMenu(meta) {
			const client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})

			let show = false

			switch (meta) {
				case 'presential_manager_catalog':
					show = client && client.presential_event_catalog;
					break;
				case 'rewards':
					show = client && client.has_rewards_store;
					break;
				default:
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === meta
					})
					if (obj) show = obj.permission
			}

			return show
		},

		changeLogo() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (client) this.logo = client.logo
		},

		getColorRegistrations() {
			let meta_array = [
				'users',
				'users_groups',
				'headquarter',
				'branch',
				'tags',
				'reward_sale_products',
				'reward_brands',
				'reward_sale_product_types',
				'reward_upload_file_types',
			]

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorRewards() {
			let meta_array = [
				'rewards',
			]

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorFiles() {
			let meta_array = ['library_categories', 'library']

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorTraining() {
			let meta_array = [
				'trainings',
				'appointments',
				'appointment_types',
				'product_categories',
				'products',
				'support_materials',
				'trails',
				'webcasts',
				'podcasts',
				'live_classes',
				'courses_catalog',
				'planned_vacancies',
			]

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorFourTraders() {
			let meta_array = ['4traders_questions', '4traders_tasks']

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorComunications() {
			let meta_array = [
				'surveys',
				'messages',
				'news',
				'faq',
				'faq_categories',
				'banners',
				'banners_welcome',
				'calendar',
			]

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},

		getColorConfigurations() {
			let meta_array = [
				'configuration',
				'terms',
				'about',
				'policy',
				'cookies_policy',
				'badges',
				'users_import',
				'headquarter_import',
				'area_config',
				'mailing_list',
			]

			let item = meta_array.find((obj) => {
				return obj === this.$route.meta.title
			})
			if (item) return 'primary'
			else return 'secondary'
		},
	},

	watch: {
		params_loaded: function () {
			this.changeLogo()
		},

		id_user_client_selected: function () {
			this.changeLogo()
		},
	},

	mounted() {
		if (this.clients) {
			this.changeLogo()
		}
	},
}
</script>

<style></style>
